import { AdTypes } from '@xing-com/crate-common-graphql-types';
import { createContentReportMock } from '@xing-com/crate-hooks-use-content-report/src/mocks';
import type { msw } from '@xing-com/crate-xinglet';

import type { AdAuctionWinnerAdPreviewQuery } from './auction-ad-preview.gql-types';
import type {
  AdAuctionWinnersQuery,
  WebsiteAdFieldsFragment,
  VideoAdFieldsFragment,
} from './auction-ads.gql-types';

const IMAGE_PROFILE_ORIGINAL = '/test-assets/1024x1024x000xfff.png';
const VIDEO_FILE = '/test-assets/1-sample-vid.mp4';
const AD_IMAGE_LARGE = '/test-assets/1920x1080xccc.png';
const AD_DESCRIPTION =
  'A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart. ';
const AD_TARGET_URL = 'https://apod.nasa.gov/apod/ap200118.html';
const AD_SENDER_LINK = '/test-assets/128x128xdddx000.png';

export const websiteAd: WebsiteAdFieldsFragment = {
  id: 54,
  __typename: 'AuctionWebsiteAd',
  type: AdTypes.WebsiteAd,
  surn: 'surn:x-xing:activities:activity:30092072.daabca',
  description: AD_DESCRIPTION,
  image: {
    __typename: 'AdImage',
    small: AD_IMAGE_LARGE,
    large: null,
  },
  title: 'My new Website Ad creation - whole lotta craziness',
  trackingToken:
    '554987a97b206a8f.YWRfZGVsaXZlcnlfaWQ9MzIwNiZjaGFubmVsPXN0YXJ0cGFnZV93ZWImcHJpY2U9MC4wMTAwMCZ0aW1lPTE2MDQ0MjUyMjY',
  targetUrl: AD_TARGET_URL,
  siteName: 'https://apod.nasa.gov/apod/ap200118.html',
  sender: {
    __typename: 'AdSender',
    image: IMAGE_PROFILE_ORIGINAL,
    name: 'The Kensington Arms with a veeeeeeeeeeeeeeery loooooooooooooooooooooooooooooooooooooooong nameeeeeeeeeeeeeeeeeeeee - phew!',
    link: AD_SENDER_LINK,
    urn: 'urn',
    jobDescription:
      'New work SE - for a better working life - working better is very important so do better than yesterday as this also helps the poor and unheard - can I hear an amen?',
    followersCount: null,
  },
};

export const videoAd: VideoAdFieldsFragment = {
  id: 75,
  __typename: 'AuctionVideoAd',
  type: AdTypes.VideoAd,
  surn: 'surn:x-xing:activities:activity:30092072.daabca',
  description: AD_DESCRIPTION,
  title: 'My new Video Ad creation - whole lotta craziness',
  trackingToken:
    '554987a97b206a8f.YWRfZGVsaXZlcnlfaWQ9MzIwNiZjaGFubmVsPXN0YXJ0cGFnZV93ZWImcHJpY2U9MC4wMTAwMCZ0aW1lPTE2MDQ0MjUyMjY',
  targetUrl: AD_TARGET_URL,
  sender: {
    __typename: 'AdSender',
    image: IMAGE_PROFILE_ORIGINAL,
    name: 'The Kensington Arms with a veeeeeeeeeeeeeeery loooooooooooooooooooooooooooooooooooooooong nameeeeeeeeeeeeeeeeeeeee - phew!',
    link: AD_SENDER_LINK,
    urn: 'urn',
    jobDescription:
      'New work SE - for a better working life - working better is very important so do better than yesterday as this also helps the poor and unheard - can I hear an amen?',
    followersCount: null,
  },
  siteName: 'https://apod.nasa.gov/apod/ap200118.html',
  videoId: '46.b866d0',
  showed: false,
};

export function getAuctionWinnersMock({
  adTypes = [AdTypes.WebsiteAd],
  adCount = 1,
}: {
  adTypes: AdTypes[];
  adCount: number;
}): AdAuctionWinnersQuery {
  return {
    __typename: 'Query',
    adAuctionWinners: {
      __typename: 'AdAuctionWinners',
      collection: Array(adCount)
        .fill(undefined)
        .map((_, i) => {
          const adType = adTypes[i % adTypes.length];
          switch (adType) {
            case AdTypes.WebsiteAd:
              return websiteAd;
            case AdTypes.VideoAd:
              return videoAd;
            default:
              return websiteAd;
          }
        }),
    },
  };
}

export function getAuctionWinnerAdPreviewMock(
  adId: number
): AdAuctionWinnerAdPreviewQuery {
  return {
    __typename: 'Query',
    adAuctionWinnerAdPreview: {
      ...([websiteAd, videoAd].find(({ id }) => id === adId) || websiteAd),
    },
  };
}

export function setupMocking({ worker, graphql }: msw): void {
  worker.use(
    graphql.query<AdAuctionWinnersQuery>(
      'AdAuctionWinners',
      (req, res, ctx) => {
        return res(
          ctx.data(getAuctionWinnersMock(req.variables.auctionWinnersInput))
        );
      }
    )
  );

  worker.use(
    graphql.query<AdAuctionWinnerAdPreviewQuery>(
      'AdAuctionWinnerAdPreview',
      (req, res, ctx) => {
        return res(ctx.data(getAuctionWinnerAdPreviewMock(req.variables.adId)));
      }
    )
  );

  worker.use(
    graphql.query('Video', (_req, res, ctx) => {
      return res(
        ctx.data({
          __typename: 'Query',
          videoV2: {
            ref: '37.8c0ac9',
            globalId: 'surn:x-xing:videos:video:46.b866d0',
            ownerGlobalId: 'surn:x-xing:users:user:194.c66fb8',
            status: 'AVAILABLE',
            sources: [
              {
                __typename: 'VideoSource',
                format: 'application/x-mpegURL',
                source: VIDEO_FILE,
              },
              {
                __typename: 'VideoSource',
                format: 'application/dash+xml',
                source: VIDEO_FILE,
              },
            ],
            subtitles: null,
            defaultThumbnails: [
              {
                __typename: 'VideoThumbnail',
                sources: [
                  {
                    __typename: 'VideoImageSource',
                    source: AD_IMAGE_LARGE,
                    width: 1200,
                    height: 700,
                  },
                ],
              },
            ],
            customThumbnails: [
              {
                __typename: 'VideoThumbnail',
                sources: [
                  {
                    __typename: 'VideoImageSource',
                    source: AD_IMAGE_LARGE,
                    width: 1200,
                    height: 700,
                  },
                ],
              },
            ],
            sprites: [
              {
                __typename: 'VideoSprite',
                sources: [
                  {
                    __typename: 'VideoImageSource',
                    height: 45,
                    width: 80,
                    source: AD_IMAGE_LARGE,
                  },
                  {
                    __typename: 'VideoImageSource',
                    height: 90,
                    width: 160,
                    source: AD_IMAGE_LARGE,
                  },
                ],
              },
            ],
            __typename: 'VideoV2',
          },
        })
      );
    })
  );

  worker.use(
    graphql.mutation('createVideoTrackingEvent', (_req, res, ctx) => {
      return res(
        ctx.data({
          videoTracking: {
            __typename: 'VideoTrackingMutationResult',
            error: null,
          },
        })
      );
    })
  );

  worker.use(
    graphql.mutation('createContentReport', (_req, res, ctx) => {
      return res(ctx.delay(200), ctx.data(createContentReportMock()));
    })
  );
}
